import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';

interface BannerImage{
  image: any,
  page: number,
  imagePath: any,
  status: boolean,
  edit: boolean
}

@Component({
  selector: 'app-edit-banner-image',
  templateUrl: './edit-banner-image.component.html',
  styleUrls: ['./edit-banner-image.component.css']
})
export class EditBannerImageComponent {

  bannerForm: FormGroup

  edit: boolean

  constructor(
    public dialogRef: MatDialogRef<EditBannerImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BannerImage) {
      this.bannerForm = new FormGroup({
        status: new FormControl('', [Validators.required]),
        page: new FormControl({value: null, disabled: data.edit}, [Validators.required]),
        image: new FormControl(null)
      })
      let bannerInstance = Object.assign({}, data)
      delete bannerInstance['imagePath']
      delete bannerInstance['edit']
      this.bannerForm.setValue(bannerInstance)
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  pages = [
    {value: 1, viewValue: 'Home Page'},
    {value: 2, viewValue: 'About Page'},
    {value: 3, viewValue: 'Contact Page'},
    {value: 4, viewValue: 'Blog Page'}
  ]

  fileChangeEvent(event: any){
    let image = event.target.files[0]
    this.bannerForm['controls']['image'].setValue(image)
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]); 
    reader.onload = (_event) => { 
      this.data.imagePath = reader.result; 
    }
  }

  saveBanner(){
    if(this.bannerForm.valid){
      this.dialogRef.close(this.bannerForm.value)
    }
  }

}
